export default __webpack_public_path__ + "static/media/child1.a66110d9.jpg";